import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "@dmms/core/http";
import { IApiResponse, IBaseHttpResponse } from "@models/http/http-options";
import { NotificationEndpoints } from "../types/notification-endpoints";
import { INotificationResponsePagination } from "@dmms/shared/data-access/notification/models/notification";
import { IPagination } from "@models/core/pagination";

@Injectable({
  providedIn: "root",
})
export class NotificationApiService extends BaseService {
  getNotifications(
    params: Partial<IPagination & { isRead?: boolean; isNotRead?: boolean }> = {},
    version = 1,
  ): Observable<INotificationResponsePagination> {
    return this.get<INotificationResponsePagination>(
      `v${version}/${NotificationEndpoints.Notification}`,
      params,
    );
  }

  getNotificationsUnreadCount(version = 1): Observable<IApiResponse<number>> {
    return this.get<IApiResponse<number>>(
      `v${version}/${NotificationEndpoints.NotificationUnreadCount}`,
    );
  }

  markNotificationAsRead(
    id: string,
    version = 1,
  ): Observable<IBaseHttpResponse> {
    return this.post<IBaseHttpResponse>(
      `v${version}/${NotificationEndpoints.NotificationMarkAsRead.replace("{id}", id)}`,
      {},
    );
  }

  markAllNotificationsAsRead(version = 1): Observable<IBaseHttpResponse> {
    return this.post<IBaseHttpResponse>(
      `v${version}/${NotificationEndpoints.NotificationMarkAllAsRead}`,
      {},
    );
  }
}
